import { inject, Injectable } from "@angular/core";
import { CanActivate, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { StorageHandlerService } from "../services";

@Injectable({
  providedIn: "root",
})
export class UnAuthGuard implements CanActivate {
  private readonly storageHandlerService = inject(StorageHandlerService);

  constructor() {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const checkUser = this.storageHandlerService.getItem("token");
    if (!checkUser) {
      this.storageHandlerService.clearAll();
      return true;
    }
    return false;
  }
}
